









































import {
    Component,
    Vue,
    Prop
} from 'vue-property-decorator';

@Component
export default class BannerHome extends Vue {
    @Prop({ required: false }) private postion!: string;
    @Prop({ required: true }) private title!: string;
    @Prop({ required: true }) private subTitle!: string;
    @Prop({ required: false }) private mark!: string;
    @Prop({ required: true }) private imgUrl!: string;
    @Prop({ required: true }) private id!: string;
    get imgUrlStyle() {
        return `background-image: url(${this.imgUrl})` ;
    }
    get subTitleHtml() {
        return this.mark ? this.subTitle.replace(new RegExp(this.mark, 'g'), `<span>${this.mark}</span>`) : this.subTitle;
    }
}
